import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
} from '@mui/material';
import { toast } from 'react-toastify';
import { api } from '../contexts/AuthContext';

export default function ChangePasswordDialog({ open, onClose }) {
  const [passwords, setPasswords] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (field) => (event) => {
    setPasswords({
      ...passwords,
      [field]: event.target.value,
    });
  };

  const handleSubmit = async () => {
    if (passwords.newPassword !== passwords.confirmPassword) {
      toast.error('New passwords do not match');
      return;
    }

    setLoading(true);
    try {
      await api.post('/api/users/change-password', {
        currentPassword: passwords.currentPassword,
        newPassword: passwords.newPassword,
      });
      toast.success('Password changed successfully');
      onClose();
      // Reset form
      setPasswords({
        currentPassword: '',
        newPassword: '',
        confirmPassword: '',
      });
    } catch (error) {
      console.error('Failed to change password:', error);
      toast.error(error.response?.data?.message || 'Failed to change password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Change Password</DialogTitle>
      <DialogContent>
        <TextField
          fullWidth
          margin="normal"
          label="Current Password"
          type="password"
          value={passwords.currentPassword}
          onChange={handleChange('currentPassword')}
          required
        />
        <TextField
          fullWidth
          margin="normal"
          label="New Password"
          type="password"
          value={passwords.newPassword}
          onChange={handleChange('newPassword')}
          required
        />
        <TextField
          fullWidth
          margin="normal"
          label="Confirm New Password"
          type="password"
          value={passwords.confirmPassword}
          onChange={handleChange('confirmPassword')}
          required
          error={passwords.newPassword !== passwords.confirmPassword}
          helperText={
            passwords.newPassword !== passwords.confirmPassword
              ? 'Passwords do not match'
              : ''
          }
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          color="primary"
          disabled={loading || !passwords.currentPassword || !passwords.newPassword || !passwords.confirmPassword}
        >
          Change Password
        </Button>
      </DialogActions>
    </Dialog>
  );
} 